<template>
  <div
    class="two-drawer-layout__screen-height--after-secondary-subheader tw-p-6"
  >
    <div
      class="
        tw-rounded-lg
        tw-h-full
        tw-max-w-condensed-content
        tw-mx-auto
        tw-flex
        tw-flex-row
        tw-w-full
      "
      :class="borderClasses"
    >
      <InboxV2Empty v-if="empty && !loading" />
      <template v-else>
        <div
          class="
            tw-h-full
            tw-shrink-0
            tw-grow
            tw-rounded-l-lg
            tw-p-4
            tw-max-w-condensed-sidepane
            tw-w-condensed-sidepane
            tw-overflow-y-auto
            tw-bg-sf-neutral-subtle-1
          "
        >
          <FirmInboxV2LeftSidepane />
        </div>
        <div
          class="
            tw-h-full
            tw-shrink
            tw-grow
            tw-overflow-y-auto
            tw-bg-sf-snow-lighter
            tw-rounded-r-lg
          "
        >
          <FirmInboxV2CompanyPanel />
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import FirmInboxV2LeftSidepane from '@app/application/communication/screens/inbox/components/firm-inbox-v2-left-sidepane.vue'
import FirmInboxV2CompanyPanel from '@app/application/communication/screens/inbox/components/firm-inbox-v2-company-panel.vue'
import InboxV2Empty from '@app/application/communication/screens/inbox/components/inbox-v2-empty.vue'
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const companies = computed(() =>
  Object.keys(store.state.notifications.companies)
)
const empty = computed(() => companies.value.length === 0)
const loading = computed(() => store.getters.loadingCompanies)

const borderClasses = computed(() => {
  return empty.value && !loading.value
    ? []
    : ['tw-border', 'tw-border-solid', 'tw-border-sf-neutral-lighter-2']
})

store.dispatch('fetchCompanies')
</script>

<style scoped lang="scss">
a .icon {
  color: inherit !important;
}
</style>
